import React from 'react';
import { useSelector } from 'react-redux';
import { ChevronLeftIcon, PlusSquareIcon, ChatIcon, StarIcon } from "@chakra-ui/icons";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  IconButton,
  Badge,
  Button,
} from '@chakra-ui/react'
import { BsEye } from 'react-icons/bs';


const UserList = () => {
	let users = useSelector((state) => state.auth.users);
	let socket = useSelector((state) => state.auth.socket);
	let userList = [];
	let online = users.length;
	let uncredentialed = 0;
	for (let el of users) {
		uncredentialed = 0;
		if (el.username !== undefined) {
			userList.push(el);
		}
	}

	return (
      <Popover >
        <PopoverTrigger>
          <Button style={{ backgroundColor: '#5a4b5c' }} color={'white'} leftIcon={<BsEye />} circle size="md"><Badge>{userList.length}</Badge></Button>
        </PopoverTrigger>
        <PopoverContent style={{ backgroundColor: '#5a4b5c' }}>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>Online Users: {online}</PopoverHeader>
          <PopoverBody  >
            {uncredentialed > 0 ? (
                <span>{uncredentialed} not signed in</span>
              ) : null}
              {userList.length > 0 && socket !== null ? (
                <React.Fragment>
                  <ul>
                    {userList.map((user, index) => (
                      <li id={user.username + index} key={user.character}>
                        {user.character} | {user.clientVersion}{' '}
                      </li>
                    ))}
                  </ul>
                </React.Fragment>
              ) : null}
          </PopoverBody>
        </PopoverContent>
      </Popover>
	);
};

export default UserList;
